var _circle, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstallinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.729 14.826a.209.209 0 00.061-.148l.002-3.487a1.223 1.223 0 012.445 0v3.49a.209.209 0 00.209.21h1.419a.815.815 0 01.576 1.388l-2.85 2.852a.816.816 0 01-1.152 0l-2.852-2.852a.814.814 0 01.576-1.392h1.418a.209.209 0 00.148-.061z",
    fill: "#0F0449"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.642 21.818h14.715a2.455 2.455 0 012.453 2.455v3.274A2.455 2.455 0 0127.357 30H12.642a2.455 2.455 0 01-2.452-2.457v-3.27a2.455 2.455 0 012.452-2.455zm1.61 3.741a.614.614 0 00-.179.434v.006a.613.613 0 00.613.607h3.02a.616.616 0 00.587-.854.612.612 0 00-.587-.373h-3.02a.613.613 0 00-.433.18zm10.788 1.363c.202.135.44.207.682.207v.006a1.228 1.228 0 10-.865-2.102 1.225 1.225 0 00.183 1.889z",
    fill: "#0F0449"
  })));
}

export default SvgInstallinline;